import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNotifications } from "./Dashboard/hooks/useNotifications";

// Sidebar departments
const departments = [
    { name: "शोध एवं प्रकाशन परिचय", id: "researchJournal" },
    { name: "शोध पत्रिका (कापिष्ठलम्)", id: "kapishthalam" },
    { name: "विश्वविद्यालय समाचार पत्र (महर्षि प्रभा)", id: "universityNewspaper" },
    { name: "प्रकाशित पुस्तकें", id: "publications" },
    { name: "सम्पर्क", id: "contact" }
];

// Map department ID to API 'location' param
const locationMap = {

    kapishthalam: "kapishthalam",
    universityNewspaper: "universityNewspaper",
    publications: "publications",
    contact: "contact"
};

export default function ResearchandPublication() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("researchJournal");
    const [location, setLocation] = useState(locationMap["researchJournal"]);

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        setLocation(locationMap[deptId]); // Dynamically set location for API
        setShowSidebar(false);
    };

    const { notifications, loading, handleNotificationClick } = useNotifications(location);

    const renderPDFSection = () => {
        return loading ? (
            <p>लोड हो रहा है...</p>
        ) : notifications?.length > 0 ? (
            <table className="table table-bordered small">
                <thead className="table-secondary">
                    <tr>
                        <th>शीर्षक</th>
                        <th>डाउनलोड</th>
                    </tr>
                </thead>
                <tbody>
                    {notifications.map((session, index) => (
                        <tr key={index}>
                            <td>{session.title_Hindi}</td>
                            <td>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => handleNotificationClick(session)}
                                >
                                    डाउनलोड करें
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : (
            <p className="text-muted">कोई पीडीएफ उपलब्ध नहीं है।</p>
        );
    };

    const departmentContent = {
        "researchJournal": (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    शोध एवं प्रकाशन परिचय
                </h5>
                <p className="mb-2 text-justify">
                    महर्षि वाल्मीकि संस्कृत विश्वविद्यालय द्वारा अगस्त 2021 में शोध एवं प्रकाशन विभाग का संचालन किया गया। तब से विभाग प्रकाशन सम्बन्धित कार्यों को निरन्तर कर रहा है। शोध एवं प्रकाशन विभाग द्वारा मासिक ई-पत्रिका महर्षि प्रभा, षाण्मासिकी शोध पत्रिका कापिष्ठलम्, विश्वविद्यालयीय वार्षिक विवरणिका (Prospectus) एवं पुस्तकों के प्रकाशन का कार्य किया जा रहा है।
                </p>
                <h6 className="mb-2 fw-bold text-secondary">शोध एवं प्रकाशन के कार्य एवं उद्देश्य:</h6>
                <p className="mb-2 text-justify">
                    शोध एवं प्रकाशन विभाग का मुख्य उद्देश्य शोध गतिविधियों को बढ़ावा देना, पुस्तकों, पत्रिकाओं एवं शोध परिणामों को प्रकाशित करना और अकादमिक समुदाय के साथ ज्ञान को साझा करना है।
                </p>

                <h6 className="mb-2 fw-bold text-secondary">पुस्तकों एवं पत्रिकाओं का प्रकाशन:</h6>
                <p className="mb-2 text-justify">
                    महर्षि वाल्मीकि संस्कृत विश्वविद्यालय के प्रथम दीक्षान्त समारोह के अवसर पर महामहीम राज्यपाल श्री बंडारू दत्तात्रेय द्वारा शोध एवं प्रकाशन विभाग द्वारा प्रकाशित निम्न पुस्तकों का विमोचन किया गया।
                </p>

                <h6 className="mb-2 text-secondary">📚 पुस्तकों का प्रकाशन:</h6>
                <ul className="mb-3">
                    <li>कैथल (कपिष्ठल) का इतिहास</li>
                    <li>भारतीय ज्ञान परम्परा : विविध आयाम</li>
                    <li>महर्षि वाल्मीकि का जीवन दर्शन</li>
                    <li>मन्दिर एवं तीर्थ प्रबन्धन</li>
                    <li>संस्कृत साहित्य में सरस्वती</li>
                </ul>

                <h6 className="mb-2 text-secondary">📰 षाण्मासिक शोध पत्रिका का प्रकाशन:</h6>
                <ul>
                    <li>कापिष्ठलम् (अंक – 1, जून 2024)</li>
                    <li>कापिष्ठलम् (अंक – 2, दिसम्बर 2024)</li>
                </ul>
            </div>
        ),

        kapishthalam: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    षाण्मासिक शोध पत्रिका (कापिष्ठलम्)
                </h5>
                <h6 className="mb-3 text-secondary">PDF लिंक:</h6>
                {renderPDFSection()}
            </div>
        ),
        universityNewspaper: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    विश्वविद्यालय समाचार पत्र (महर्षि प्रभा)
                </h5>

                <h6 className="mb-3 text-secondary">PDF लिंक:</h6>
                {renderPDFSection()}
            </div>
        ),
        publications: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    प्रकाशित पुस्तकें
                </h5>
                <p className="mb-2 text-justify">नीचे प्रकाशित पुस्तकें उपलब्ध हैं:</p>
                {renderPDFSection()}
            </div>
        ),
        contact: (
            <div>
                <h5 className="mb-3 text-center" style={{ color: "#77236b" }}>
                    सम्पर्क
                </h5>

                {/* शैक्षणिक अधिकारी */}
                <h6 className="mt-4">शोध एवं प्रकाशन विभाग के अधिकारीगण</h6>
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th>क्रं. सं.</th>
                                <th>अधिकारी का नाम</th>
                                <th>पद</th>
                                <th>दूरभाष नं.</th>
                                <th>ई-मेल</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>डॉ. कृष्ण चन्द्र पाण्डेय</td>
                                <td>प्रभारी (शोध एवं प्रकाशन विभाग)</td>
                                <td>98103-73278</td>
                                <td>
                                    research@mvsu.ac.in<br />
                                    publication@mvsu.ac.in
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* गैर-शैक्षणिक सदस्य */}
                <h6 className="mt-4">शोध एवं प्रकाशन में कार्यरत गैर-शैक्षणिक सदस्य</h6>
                <div className="table-responsive">
                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th>क्रं. सं.</th>
                                <th>सदस्य का नाम</th>
                                <th>पद</th>
                                <th>दूरभाष नं.</th>
                                <th>ई-मेल</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>श्री मुकेश कुमार</td>
                                <td>लिपिक (HKRN)</td>
                                <td>95921-23777</td>
                                <td>
                                    research@mvsu.ac.in<br />
                                    publication@mvsu.ac.in
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>

        )
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{ backgroundColor: "#77236b", borderColor: "#77236b" }}
            >
                ☰ मेनू
            </button>

            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">शोध एवं प्रकाशन</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeContentId === dept.id ? "#77236b" : undefined,
                                fontWeight: activeContentId === dept.id ? "bold" : "normal"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto" onClick={() => setShowSidebar(false)}>
                {departmentContent[activeContentId] || <p className="text-muted">कृपया किसी अनुभाग का चयन करें।</p>}
            </main>
        </div>
    );
}
